import styled, { css } from 'styled-components';
import _ from 'lodash';
import Button from 'components/Button';
import { colorVariables, fontVariables } from 'theme/variables';

export const DefaultInputStyled = styled.div`
  position: relative;
  width: 100%;

  ${(props) =>
    props.align === 'center' &&
    css`
      text-align: center;
    `};
`;

export const Wrapper = styled.div`
  width: 100%;
  border: 1px solid ${colorVariables.white_verylightgainsboro};
  border-radius: 10px;
  background-color: white;
  display: flex;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;

  ${(props) =>
    props.focused &&
    css`
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
      border-color: transparent;
    `} ${(props) =>
    props.isError &&
    css`
      border: 1px solid ${colorVariables.red};
    `};
`;

export const InputButtonStyled = styled.div`
  position: relative;
`;

export const StyledButton = styled(Button)`
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  background-color: white;
  z-index: 1;
`;

const StyledMixedInput = css`
  width: 100%;
  padding: 16px;
  border: none;
  border-radius: 3px;
  background-color: transparent;

  ${(props) => css`
    color: ${_.get(
      colorVariables,
      props.color,
      colorVariables.gray_nightrider
    )};
    font-size: ${_.get(fontVariables, props.fontSize, fontVariables.fs_md)};
  `};

  font-weight: ${(props) =>
    props.font === 'inherit' && props.fontWeight !== ''
      ? props.fontWeight
      : 'inherit'};
  text-overflow: ellipsis;
  outline: none;

  &:-webkit-autofill {
    box-shadow: 0 0 0 30px white inset;
  }

  &:focus {
    &::placeholder {
      color: ${colorVariables.gray_lightgray};
    }

    &::-webkit-input-placeholder {
      color: ${colorVariables.gray_lightgray};
    }

    &::-moz-placeholder {
      color: ${colorVariables.gray_lightgray};
    }

    &:-ms-input-placeholder {
      color: ${colorVariables.gray_lightgray};
    }
  }

  &::placeholder {
    color: ${colorVariables.gray};
  }

  &::-webkit-input-placeholder {
    color: ${colorVariables.gray};
  }

  &::-moz-placeholder {
    color: ${colorVariables.gray};
  }

  &:-ms-input-placeholder {
    color: ${colorVariables.gray};
  }
`;
export const StyledInput = styled.input`
  ${StyledMixedInput};
`;
